export enum NavItemType {
  Button = 'button',
  RouteLink = 'router-link',
  ExternalLink = 'external-link',
  RouteButton = 'router-button',
  Anchor = 'anchor',
}

export type NavItemTypeValue = `${NavItemType}`;
